(function() {

    /* globals app, api, tracker */

    'use strict';

    var Tracker = function Tracker() {};

    Tracker.prototype.count = function(options) {

        options = options || {};

        api.post('/call_tracking', JSON.stringify(options));

    };

    Tracker.prototype.observe = function(selector, event) {

        app.addDelegatedListener(document.querySelector('body'), selector, 'click', function(e) {

            var controller = document.querySelector('meta[name="controller"]').content,
                options = {},
                contactId = e.target.dataset.contactId,
                locationId = e.target.dataset.locationId;

            if(controller === 'single_calls') {
                controller = 'calls'
            }

            // track only calls and follow ups
            if(controller !== 'calls' && controller !== 'follow_ups' ) {
                return;
            }

            options['call_type'] = controller;

            if(contactId === undefined) {
                return;
            }

            options['contact_id'] = contactId;

            if(locationId !== undefined) {
                options['location_id'] = locationId;
            }

            this.count(options);

        }.bind(this));

    };

    window.tracker = new Tracker();

    tracker.observe('a[href^="tel:"]', 'click');

})();